import { Injectable } from '@angular/core';
import { addDoc, collection, collectionData, deleteDoc, doc, Firestore, getDoc, getDocs, orderBy, query, updateDoc } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { AreaItem } from '../models/area-item';

@Injectable()
export class AreaItemService {
  constructor(
    private firestore: Firestore
  ) {}

  /**
   *
   * @param sectionId
   * @param reportId
   * @param areaId
   * @returns An Observable of area items with an ID
   */
  readAllByAreaId(sectionId: string, reportId: string, areaId: string) {

    const areaItemsCollectionRef = collection(this.firestore, `sections/${sectionId}/templates/${reportId}/areas/${areaId}/items`);
    const areaItemsQuery = query(areaItemsCollectionRef, orderBy('date', 'asc'));
    return collectionData(areaItemsQuery, { idField: 'id' }) as Observable<any[]>;
  }

  async deleteAsync(sectionId: string, reportId: string, areaId: string, itemId: string): Promise<void> {
    const areaItemRef = doc(this.firestore, `sections/${sectionId}/templates/${reportId}/areas/${areaId}/items/${itemId}`);
    return deleteDoc(areaItemRef);
  }

  async readSnapshotByIdAsync(sectionId: string, reportId: string, areaId: string, itemId: string): Promise<AreaItem> {
    const areaItemRef = doc(this.firestore, `sections/${sectionId}/templates/${reportId}/areas/${areaId}/items/${itemId}`);
    const snapshot =  await getDoc(areaItemRef);

    return snapshot.data() as AreaItem;
  }

  async createAsync(sectionId: string, reportId: string, areaId: string, areaItem: AreaItem, createdBy: string) {
    const areaItemsCollection = collection(this.firestore, `sections/${sectionId}/templates/${reportId}/areas/${areaId}/items/`);
    const snapshot = await getDocs(areaItemsCollection);
    areaItem.order = snapshot.size + 1;

    return addDoc(areaItemsCollection, {
      name: areaItem.name,
      order: snapshot.size + 1,
      date: new Date(),
      createdBy: createdBy,
    });
  }

   async updateAsync(sectionId: string, reportId: string, areaId: string, areaItemId: string, name: string, modifiedBy: string): Promise<void> {
    const areaItemRef = doc(this.firestore, `sections/${sectionId}/templates/${reportId}/areas/${areaId}/items/${areaItemId}`);
    return updateDoc(areaItemRef, {
      name: name,
      modifiedBy: modifiedBy,
      updateDate: new Date()
    });
  }


}
